export default __webpack_public_path__ + "static/media/list-chevron.da9aadef.svg";